<template>
  <div class="container">
    <div class="section">
      <h1 class="title content-title">
        <span class="icon">
          <i class="material-icons is-size-2">storage</i>
        </span>
        Auditoría de Base de Datos
      </h1>

      <!-- Filtros -->
      <div class="box">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Tipo de Movimiento</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filters.action">
                    <option value="">Todos los movimientos</option>
                    <option value="create">Creación</option>
                    <option value="update">Edición</option>
                    <option value="delete">Eliminación</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field">
              <label class="label">Módulo</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filters.collection_name">
                    <option value="">Todos los módulos</option>
                    <option
                      v-for="module in modulosDisponibles"
                      :key="module"
                      :value="module"
                    >
                      {{ module }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field">
              <label class="label">Buscador</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder="Buscar por usuario o cliente..."
                  v-model="filters.search"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Fecha Desde</label>
              <div class="control">
                <input class="input" type="date" v-model="filters.dateStart" />
              </div>
            </div>
          </div>

          <div class="column">
            <div class="field">
              <label class="label">Fecha Hasta</label>
              <div class="control">
                <input class="input" type="date" v-model="filters.dateEnd" />
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label">&nbsp;</label>
              <div class="control">
                <div class="buttons">
                  <button
                    class="button is-link"
                    v-if="false"
                    @click="aplicarFiltros"
                  >
                    <span class="icon">
                      <i class="material-icons">search</i>
                    </span>
                    <span>Buscar</span>
                  </button>
                  <button class="button is-light" @click="limpiarFiltros">
                    <span class="icon">
                      <i class="material-icons">delete_sweep</i>
                    </span>
                    <span>Limpiar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estadísticas -->
      <div class="columns">
        <div class="column">
          <div class="box has-text-centered">
            <p class="heading">Total Movimientos</p>
            <p class="title">{{ logsFiltered.length }}</p>
          </div>
        </div>
        <div class="column">
          <div class="box has-text-centered">
            <p class="heading">Creaciones</p>
            <p class="title has-text-success">{{ getCountByTipo("create") }}</p>
          </div>
        </div>
        <div class="column">
          <div class="box has-text-centered">
            <p class="heading">Ediciones</p>
            <p class="title has-text-warning">{{ getCountByTipo("update") }}</p>
          </div>
        </div>
        <div class="column">
          <div class="box has-text-centered">
            <p class="heading">Eliminaciones</p>
            <p class="title has-text-danger">{{ getCountByTipo("delete") }}</p>
          </div>
        </div>
      </div>

      <!-- Controles de vista -->
      <div class="box">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <div class="field">
                <div class="control">
                  <div class="select">
                    <select v-model="registrosPorPagina">
                      <option value="5">5 por página</option>
                      <option value="10">10 por página</option>
                      <option value="25">25 por página</option>
                      <option value="50">50 por página</option>
                      <option value="100">100 por página</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="level-right">
            <div class="level-item">
              <button class="button is-info" @click="exportarLogs">
                <span class="icon">
                  <i class="fas fa-download"></i>
                </span>
                <span>Exportar</span>
              </button>
            </div>
          </div> -->
        </div>
      </div>

      <!-- Tabla de Logs -->
      <div class="box">
        <div class="table-container">
          <table
            class="table is-fullwidth is-striped is-hoverable"
            style="table-layout: fixed;"
          >
            <thead>
              <tr>
                <th style="width: 10%;">
                  <span class="icon-text">
                    <span>Fecha/Hora</span>
                  </span>
                </th>
                <th style="width: 25%;">
                  <span class="icon-text">
                    <span>Usuario</span>
                  </span>
                </th>
                <th style="width: 30%;">
                  <span class="icon-text">
                    <span>Cliente</span>
                  </span>
                </th>
                <th class="has-text-centered" style="width: 15%;">
                  <span class="icon-text">
                    <span>Movimiento</span>
                  </span>
                </th>
                <th class="has-text-centered" style="width: 15%;">
                  <span class="icon-text">
                    <span>Módulo</span>
                  </span>
                </th>
                <th style="width: 5%;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logsPaginated" :key="log.id">
                <td>
                  <span class="has-text-weight-semibold">
                    {{ formatearFecha(log.created) }}
                  </span>
                  <br />
                  <small class="has-text-grey">
                    {{ formatearHora(log.created) }}
                  </small>
                </td>
                <td style="width: 25% !important;">
                  <div class="media">
                    <div class="media-left">
                      <figure class="image is-32x32">
                        <img
                          class="is-rounded"
                          :src="getAvatarUrl(log.username)"
                          :alt="log.username"
                        />
                      </figure>
                    </div>
                    <div class="media-content">
                      <p class="has-text-weight-semibold text-truncate">
                        {{ log.username }}
                      </p>
                      <p class="is-size-7 has-text-grey text-truncate">
                        {{ log.email }}
                      </p>
                    </div>
                  </div>
                </td>
                <td style="width: 25% !important;">
                  <div class="media">
                    <div class="media-left">
                      <figure class="image is-32x32">
                        <img
                          class="is-rounded"
                          :src="getAvatarUrl(log.client, '9632dc')"
                          :alt="log.client"
                        />
                      </figure>
                    </div>
                    <div class="media-content">
                      <p class="has-text-weight-semibold text-truncate">
                        {{ log.client }}
                      </p>
                      <p class="is-size-7 has-text-grey text-truncate">
                        Nit: {{ log.nit }}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="m-auto has-text-centered">
                  <span
                    class="tag tag-full"
                    :class="getTipoMovimientoClass(log.action)"
                  >
                    <span>{{ getTipoMovimientoTexto(log.action) }}</span>
                  </span>
                </td>
                <td class="m-auto has-text-centered">
                  <span class="tag tag-full is-dark">
                    <span class="icon">
                      <i class="material-icons">{{
                        getModuleIcon(log.collection_name)
                      }}</i>
                    </span>
                    <span>{{ modulesNames[log.collection_name] }}</span>
                  </span>
                </td>
                <td>
                  <div class="buttons are-small">
                    <button
                      class="button is-info is-outlined"
                      @click="verDetalles(log)"
                      title="Ver detalles"
                    >
                      <span class="icon">
                        <i class="material-icons">remove_red_eye</i>
                      </span>
                    </button>
                    <button
                      class="button is-primary is-outlined"
                      @click="verDatos(log)"
                      title="Ver datos"
                      v-if="log.datosMovimiento"
                    >
                      <span class="icon">
                        <i class="material-icons">storage</i>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mensaje cuando no hay logs -->
        <div v-if="logsFiltered.length === 0" class="has-text-centered p-6">
          <span class="icon is-large has-text-grey-light">
            <i class="fas fa-search fa-2x"></i>
          </span>
          <p class="has-text-grey">
            No se encontraron movimientos
          </p>
        </div>

        <!-- Paginación -->
        <nav class="pagination is-centered" v-if="totalPages > 1">
          <button
            class="pagination-previous"
            :disabled="currentPage === 1"
            @click="currentPage--"
          >
            Anterior
          </button>
          <button
            class="pagination-next"
            :disabled="currentPage === totalPages"
            @click="currentPage++"
          >
            Siguiente
          </button>
          <ul class="pagination-list">
            <li v-for="pages in visiblePages" :key="pages">
              <button
                class="pagination-link"
                :class="{ 'is-current': pages === currentPage }"
                @click="currentPage = pages"
              >
                {{ pages }}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Modal de Detalles -->
    <div class="modal" :class="{ 'is-active': mostrarModalDetalles }">
      <div class="modal-background" @click="cerrarModalDetalles"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Detalles del Movimiento</p>
          <button class="delete" @click="cerrarModalDetalles"></button>
        </header>
        <section class="modal-card-body" v-if="logSelected">
          <div class="content">
            <div class="columns">
              <div class="column">
                <h5>Información General</h5>
                <table class="table is-fullwidth">
                  <tbody>
                    <tr>
                      <td><strong>Usuario:</strong></td>
                      <td>{{ logSelected.username }}</td>
                    </tr>
                    <tr>
                      <td><strong>Cliente:</strong></td>
                      <td>{{ logSelected.client }}</td>
                    </tr>
                    <tr>
                      <td><strong>Fecha:</strong></td>
                      <td>
                        {{ formatearFechaCompleta(logSelected.created) }}
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Tipo:</strong></td>
                      <td>
                        <span
                          class="tag"
                          :class="getTipoMovimientoClass(logSelected.action)"
                        >
                          {{ getTipoMovimientoTexto(logSelected.action) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Módulo:</strong></td>
                      <td>{{ modulesNames[logSelected.collection_name] }}</td>
                    </tr>
                    <tr>
                      <td><strong>Tabla:</strong></td>
                      <td>{{ logSelected.collection_name }}</td>
                    </tr>
                    <tr>
                      <td><strong>ID Registro:</strong></td>
                      <td>{{ logSelected.document_id }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="logSelected.before || logSelected.after">
              <h5>Datos del Movimiento</h5>
              <pre
                v-if="logSelected.before"
                class="has-background-light p-4"
              ><strong>Antes</strong><br/><br/>{{JSON.stringify(logSelected.before, null, 2)}}</pre>
              <pre
                v-if="logSelected.after"
                class="has-background-light p-4"
              ><strong>Después</strong><br/><br/>{{JSON.stringify(logSelected.after, null, 2)}}</pre>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="cerrarModalDetalles">Cerrar</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";

export default {
  name: "DatabaseAuditLogs",
  data() {
    return {
      logs: [],
      filters: {
        action: "",
        collection_name: "",
        search: "",
        dateStart: "",
        dateEnd: "",
      },
      currentPage: 1,
      registrosPorPagina: 5,
      mostrarModalDetalles: false,
      logSelected: null,
      modulesNames: {
        ClimaAnexos: "Clima",
        ColaboradoresClima: "Clima",
        ClimaResponses: "Clima",
        ViewClima: "Clima",
        CohorteClima: "Clima",
        CohorteCultura: "Cultura",
        ColaboradoresCultura: "Cultura",
        ProcessCultura: "Cultura",
        CollaboratorsCultura: "Cultura",
        EmpleadosLideres: "Liderazgo",
        ProcesosLideres: "Liderazgo",
        RelacionLideres: "Liderazgo",
        Listfilelideres: "Liderazgo",
        Viewfrs: "Factores",
        Contactenos: "Contactenos",
        Carpeta: "Carpetas",
        FolderAssignment: "Carpetas",
        FolderPartes: "Carpetas",
        Guide: "Guias",
        Informe: "Informes",
        View: "Informes",
        Plantilla: "Plantillas",
        Partes: "Partes",
        Reports: "Reportes",
        Cliente: "Empresas",
        Usermg: "Usuarios",
      },
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    modulosDisponibles() {
      const modulos = [
        ...new Set(
          this.logs.map((log) => this.modulesNames[log.collection_name])
        ),
      ];
      return modulos.sort();
    },
    logsFiltered() {
      let filtered = [...this.logs];

      if (this.filters.action) {
        filtered = filtered.filter((log) => log.action === this.filters.action);
      }

      if (this.filters.collection_name) {
        filtered = filtered.filter((log) => {
          const filter = this.filters.collection_name;
          const collection = Object.entries(this.modulesNames)
            .filter(([key, item]) => item === filter)
            .map(([key]) => key);
          return collection.includes(log.collection_name);
        });
      }

      if (this.filters.search) {
        const search = this.filters.search.toLowerCase();
        filtered = filtered.filter(
          (log) =>
            log.username.toLowerCase().includes(search) ||
            log.email.toLowerCase().includes(search) ||
            log.client.toLowerCase().includes(search) ||
            log.nit.toLowerCase().includes(search)
        );
      }

      if (this.filters.dateStart) {
        const dateStart = new Date(this.filters.dateStart);
        filtered = filtered.filter((log) => new Date(log.created) >= dateStart);
      }

      if (this.filters.dateEnd) {
        const dateEnd = new Date(this.filters.dateEnd);
        dateEnd.setHours(23, 59, 59, 999);
        filtered = filtered.filter((log) => new Date(log.created) <= dateEnd);
      }

      return filtered.sort((a, b) => new Date(b.created) - new Date(a.created));
    },
    totalPages() {
      return Math.ceil(this.logsFiltered.length / this.registrosPorPagina);
    },
    logsPaginated() {
      const inicio = (this.currentPage - 1) * this.registrosPorPagina;
      const fin = inicio + parseInt(this.registrosPorPagina);
      return this.logsFiltered.slice(inicio, fin);
    },
    visiblePages() {
      const paginas = [];
      const inicio = Math.max(1, this.currentPage - 2);
      const fin = Math.min(this.totalPages, this.currentPage + 2);

      for (let i = inicio; i <= fin; i++) {
        paginas.push(i);
      }
      return paginas;
    },
  },
  created() {
    if (this.idtoken) this.getData();
  },
  methods: {
    async getData() {
      try {
        const result = await apiServices.get(`/logs`);
        if (result.data) {
          this.logs = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    aplicarFiltros() {
      this.currentPage = 1;
      // Aquí harías la llamada a tu API con los filtros
      // this.cargarLogs();
    },
    limpiarFiltros() {
      this.filters = {
        action: "",
        collection_name: "",
        username: "",
        dateStart: "",
        dateEnd: "",
      };
      this.currentPage = 1;
    },
    getTipoMovimientoClass(type) {
      const clases = {
        create: "is-success",
        update: "is-warning",
        delete: "is-danger",
      };
      return clases[type] || "is-light";
    },
    getTipoMovimientoTexto(type) {
      const textos = {
        create: "Creación",
        update: "Edición",
        delete: "Eliminación",
      };
      return textos[type] || type;
    },
    getModuleIcon(collection) {
      const module = this.modulesNames[collection];
      const iconos = {
        Clima: "ac_unit",
        Cultura: "stream",
        Liderazgo: "stars",
        Factores: "blur_on",
        Informes: "list",
        Usuarios: "group",
        Empresas: "business",
      };
      return iconos[module] || "layers";
    },
    getCountByTipo(type) {
      return this.logsFiltered.filter((log) => log.action === type).length;
    },
    formatearFecha(created) {
      return new Date(created).toLocaleDateString("es-ES");
    },
    formatearHora(created) {
      return new Date(created).toLocaleTimeString("es-ES");
    },
    formatearFechaCompleta(created) {
      return new Date(created).toLocaleString("es-ES");
    },
    getAvatarUrl(name, bg = "3272dc") {
      const letters = name
        .split(" ")
        .map((word) => word[0])
        .join(" ");
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(
        letters
      )}&background=${bg}&color=fff&size=32`;
    },
    verDetalles(log) {
      this.logSelected = log;
      this.mostrarModalDetalles = true;
    },
    verDatos(log) {
      this.verDetalles(log);
    },
    cerrarModalDetalles() {
      this.mostrarModalDetalles = false;
      this.logSelected = null;
    },
    exportarLogs() {
      // Implementar exportación a CSV
      const csv = this.convertirACSV(this.logsFiltered);
      this.descargarCSV(csv, "auditoria_logs.csv");
    },
    convertirACSV(datos) {
      const headers = [
        "Fecha",
        "Usuario",
        "Tipo",
        "Módulo",
        "Descripción",
        "Tabla",
        "ID Registro",
      ];
      const filas = datos.map((log) => [
        this.formatearFechaCompleta(log.created),
        log.username,
        this.getTipoMovimientoTexto(log.action),
        log.collection_name,
        log.descripcion,
        log.tabla,
        log.document_id,
      ]);

      return [headers, ...filas]
        .map((fila) => fila.map((campo) => `"${campo}"`).join(","))
        .join("\n");
    },
    descargarCSV(contenido, nombreArchivo) {
      const blob = new Blob([contenido], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", nombreArchivo);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.getData();
      }
    },
    filters: {
      handler() {
        this.currentPage = 1;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.table-container {
  max-height: 600px;
  overflow-y: auto;
}

.content-title {
  gap: 20px;
  display: flex;
  align-items: center;
}

.media {
  align-items: center;
}

.media-content {
  max-width: 100%;
  overflow: hidden;
}

.tag {
  font-weight: 600;
}

.tag-full {
  width: 70%;
}

.tag .icon {
  margin-right: 1.1875em !important;
}

.modal-card {
  max-height: 90vh;
  overflow-y: auto;
}

.m-auto {
  margin: auto;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

@media screen and (max-width: 768px) {
  .table-container {
    max-height: 400px;
  }

  .columns {
    flex-direction: column;
  }

  .buttons {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logs/Logs.vue